//
//
//
//
//
//


import Vue from 'vue';

export default {

    name: 'select2',

    props: ['options', 'value'],

    mounted: function mounted() {

        this.init();
    },


    methods: {
        init: function init() {
            var _this = this;

            // update options
            $(this.$el).empty().select2({
                data: this.options,
                matcher: this.matchStart
            }).val(this.value).trigger('change').on('change', function (_ref) {
                var currentTarget = _ref.currentTarget;

                _this.$emit('input', currentTarget.value);
                _this.$emit('change', currentTarget.value);
            });
        },
        matchStart: function matchStart(params, data) {

            // If there are no search terms, return all of the data
            if ($.trim(params.term) === '') {
                return data;
            }

            // Do not display the item if there is no 'text' property
            if (typeof data.text === 'undefined') {
                return null;
            }

            // `params.term` should be the term that is used for searching
            // `data.text` is the text that is displayed for the data object
            var modifiedData = {};

            var arrayWords = $.trim(params.term).split(" ");
            $.each(arrayWords, function (idx, word) {
                if (idx == 0) {
                    if (data.text.toUpperCase().indexOf(word.toUpperCase()) > -1) {
                        modifiedData = $.extend({}, data, true);
                    }
                } else {
                    if (typeof modifiedData.text === 'undefined') {
                        modifiedData = {};
                    } else {
                        if (modifiedData.text.toUpperCase().indexOf(word.toUpperCase()) > -1) {
                            modifiedData = $.extend({}, data, true);
                        } else {
                            modifiedData = {};
                        }
                    }
                }
            });

            if (typeof modifiedData.text !== 'undefined') {
                return modifiedData;
            }

            // Return `null` if the term should not be displayed
            return null;
        }
    },

    watch: {
        value: function value() {
            // update value
            $(this.$el).off().select2('destroy');
            this.init();
        },
        options: function options() {
            this.init();
        }
    },

    destroyed: function destroyed() {
        $(this.$el).off().select2('destroy');
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}],"syntax-dynamic-import"]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/templates/semperit/assets/js/modules/select2/Select2.vue
// module id = 7qtH
// module chunks = 4